import { object } from 'common/helpers'


export type CartProduct = {
  id: number
  image: string
  brand: string
  name: string
  amount?: number
  quantity?: number // TODO replace "amount" with "quantity"  - added on 6/9/20 by pavelivanov
  url: string // product link
  volume: number
  volumeUnit: string
  category: string
  type: string
  offer?: string
  price: number
  discount: number
  totalPrice: number
  totalPriceWithDiscount: number
  needDiscountOffer: boolean // TODO ask backend how it will work in Recurly - added on 5/12/20 by pavelivanov
}

export type ReducerState = {
  isFetching: boolean
  isVisible: boolean
  items: {
    subscription: {
      name: string
      amount?: number
      quantity?: number // TODO replace "amount" with "quantity"  - added on 6/9/20 by pavelivanov
      size: number
      volume: number
      volumeUnit: string
      volumeNotes: string
      price: number
    }
    products: {
      ids: number[]
      items: {
        [id: string]: CartProduct
      }
    }
  }
  discount: number
  shipping: { [key: string]: any }
  isSubscriptionExist: boolean
  areProductsExist: boolean
  isFlashSaleRemoved: boolean
  isFlashSaleExist: boolean
  totalCount: number
  subtotal: number
  totalPrice: number
  appliedPriceRules: { [key: string]: any }
  recommendationTag: string
}

export const initialState: ReducerState = {
  isFetching: false,
  isVisible: false,
  items: {
    subscription: null,
    products: {
      ids: [],
      items: {},
    },
  },
  shipping: null,
  isSubscriptionExist: false,
  areProductsExist: false,
  isFlashSaleRemoved: false,
  isFlashSaleExist: false,
  discount: 0,
  totalCount: 0,
  subtotal: 0,
  totalPrice: 0,
  appliedPriceRules: {},
  recommendationTag: null,
}

export const setVisibility = (state, payload) => ({ ...state, isVisible: payload })

export const update = (state, payload) => ({ ...state, ...payload })

export const updateProductAmount = (state, { id, amount }) => {
  if (amount > 0) {
    return object.setIn(state, `items.products.items.${id}.amount`, amount)
  }

  return state
}

export const updateProduct = (state, { id, product }) => {
  const { items: { products: { ids } } } = state

  if (product !== undefined) {
    return object.setIn(state, `items.products.items.${id}`, product)
  }

  const index = ids.indexOf(id)

  if (index >= 0) {
    // remove product
    return object.updateIn(state, 'items.products', ({ items, ids }) => {
      const newIds    = ids.filter((_id) => _id !== id)
      const newItems  = object.remove(items, id)

      return {
        ids: newIds,
        items: newItems,
      }
    })
  }

  return state
}

export const setFetching = (state, payload) => ({ ...state, isFetching: payload })

export const setTotalPrice = (state, payload) => ({ ...state, totalPrice: payload })

export const clear = () => initialState
